import { render, staticRenderFns } from "./changePasswordModal.vue?vue&type=template&id=64136f48&"
import script from "./changePasswordModal.vue?vue&type=script&lang=ts&"
export * from "./changePasswordModal.vue?vue&type=script&lang=ts&"
import style0 from "./changePasswordModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports